import { render, staticRenderFns } from "./SummitPhaseFilter.vue?vue&type=template&id=24af4df8&"
import script from "./SummitPhaseFilter.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummitPhaseFilter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports